import type { ProductModelView, ServerOutcome } from '../adapters/product-review-port';

/** A key that is stable for one attempt and changes for the next. */
export function newKey(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.floor(Math.random() * 1_000_000)}`;
}

/** Invalidates responses even when selection changes from A to B and back to A. */
export function createDurableRequestScope() {
  let generation = 0;
  return {
    invalidate() {
      generation += 1;
    },
    capture() {
      const captured = generation;
      return () => captured === generation;
    },
  };
}

export function durableProductFacts(value: ProductModelView) {
  const submission = [...value.submissions].sort((a, b) => b.revision - a.revision)[0] ?? null;
  const publication =
    [...value.publications].sort((a, b) => b.publishedVersion - a.publishedVersion)[0] ?? null;
  return { submission, publication };
}

/** Retains the render's request snapshot and one key for explicit retries. */
export function retainDurableMutation<T>(operation: (key: string) => Promise<ServerOutcome<T>>) {
  const idempotencyKey = newKey('command');
  return Object.assign(() => operation(idempotencyKey), { idempotencyKey });
}
